export default __webpack_public_path__ + "static/media/warningDescriptionThumbnail.3b67d8d4.svg";